import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=6ea2c6dc&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=6ea2c6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2c6dc",
  null
  
)

export default component.exports